import { Button } from '@/componentsV1/BaseComponents'
import './styles.scss'

interface INavButtonsProps {
  isStepComplete: boolean
  saveAndExit: () => void
  stepBack: () => void
  stepForward: () => void
  isSubmit?: boolean
  submitText?: string
  isLoading?: boolean
  forwardText?: string
}

export const NavButtons = ({
  isStepComplete,
  saveAndExit,
  stepBack,
  stepForward,
  isSubmit,
  submitText,
  isLoading,
  forwardText,
}: INavButtonsProps) => {
  if (isSubmit) {
    return (
      <div className="nav-buttons_wrapper_submit">
        <Button
          disabled={!isStepComplete || isLoading}
          loading={isLoading}
          variant="primary"
          size="medium"
          onClick={stepForward}
        >
          {submitText ? submitText : 'Submit'}
        </Button>
      </div>
    )
  }
  return (
    <div className="nav-buttons_wrapper">
      <div>
        <Button
          variant="secondary"
          size="medium"
          onClick={stepBack}
          disabled={isLoading}
        >
          Back
        </Button>
      </div>

      <div className="right-buttons">
        <Button
          className="save-and-exit"
          variant="secondary"
          size="medium"
          onClick={saveAndExit}
          style={{ marginRight: 16 }}
          disabled={isLoading}
        >
          Save and Exit
        </Button>

        <Button
          disabled={!isStepComplete || isLoading}
          loading={isLoading}
          variant="primary"
          size="medium"
          onClick={stepForward}
        >
          {forwardText ?? 'Continue'}
        </Button>
      </div>
    </div>
  )
}
